module.exports = __webpack_public_path__ + "static/pensjonat-glowne-photo01_thumb-8fc6951bace0180cef8c3ffd8a916ffc.jpg";